import { createContext, useContext } from 'react';

import type { SearchPortal } from './types';

/**
 * What a Quick Find trigger needs from its shell's provider: whether the
 * entry exists here at all, what it searches (for its name), and how to open
 * the one overlay. Several triggers (a desk field, a phone icon, a menu row)
 * share one overlay and one keyboard shortcut.
 */
export interface QuickFindControl {
  portal: SearchPortal;
  /** False on sign-in-security pages and when the person can search nothing. */
  available: boolean;
  open: boolean;
  /** "Search catalogue items, purchase requests and purchase orders". */
  placeholder: string;
  /** «⌘K» or «Ctrl K». */
  shortcutHint: string;
  /** `aria-keyshortcuts`: `Meta+K` or `Control+K`. */
  ariaKeyShortcuts: string;
  show: () => void;
}

export const QuickFindContext = createContext<QuickFindControl | null>(null);

export function useQuickFindControl(): QuickFindControl | null {
  return useContext(QuickFindContext);
}
